import { sortByOrder } from 'utils/collection-manipulation/array-sort-by';
import { Market } from 'interfaces/sportsbook-data-levels';

// for usa sports we need to show first markets witch includes overtime
const OVERTIME_MARKETS_POSTFIX = '(IncludingOvertime)';

export const getOrderedMarketsForUsaSports = (
  markets: Market[],
  marketTypes: string[]
) => {
  const orderedMarkets = [];

  orderedMarkets.push(
    ...sortByOrder(
      markets.filter(i =>
        marketTypes.some(
          marketType => `${marketType}${OVERTIME_MARKETS_POSTFIX}` === i.type
        )
      ),
      'main_order'
    )
  );

  if (!orderedMarkets.length) {
    orderedMarkets.push(
      ...sortByOrder(
        markets.filter(i =>
          marketTypes.some(marketType => marketType === i.type)
        ),
        'main_order'
      )
    );
  }

  return orderedMarkets;
};

export const findWinnerMarkersForUsaSports = (
  markets: Market[],
  marketTypes: string[]
) => {
  const foundedMarket = markets.find(i =>
    marketTypes.some(
      marketType => `${marketType}${OVERTIME_MARKETS_POSTFIX}` === i.type
    )
  );

  if (foundedMarket) {
    return foundedMarket;
  }

  return markets.find(i => marketTypes.includes(i.type));
};

export const checkIsMarketInGroupWithOvertime = (
  marketTypes: string[],
  type: string
): boolean =>
  marketTypes.some(marketType =>
    [marketType, `${marketType}${OVERTIME_MARKETS_POSTFIX}`].includes(type)
  );
